import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./LoginPage.css";
import Background from "./asserts/log.jpg";
import slide1 from "./asserts/slides/1.jpg";
import slide2 from "./asserts/slides/2.jpg";
import slide3 from "./asserts/slides/3.jpg";
import slide4 from "./asserts/slides/4.jpg";
import slide5 from "./asserts/slides/5.jpg";
import { linearGradient } from "framer-motion/m";

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const [forgotOpen, setForgotOpen] = useState(false);
const [email, setEmail] = useState("");
const [loadingForgot, setLoadingForgot] = useState(false);

const handleForgot = async () => {
  if (!email) {
    alert("Введите email");
    return;
  }

  try {
    setLoadingForgot(true);

    await fetch(`/api/auth/forgot-password?email=${encodeURIComponent(email)}`, {
      method: "POST",
    });

    alert("Если email существует, письмо отправлено");
    setForgotOpen(false);
    setEmail("");
  } catch (e) {
    alert("Ошибка отправки");
  } finally {
    setLoadingForgot(false);
  }
};
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
    padding: "10px",
  },
  modal: {
    background: "#242121",
    padding: "25px",
    borderRadius: "12px",
    width: "80%",
    maxWidth: "400px",
    color: "#fff",
    textAlign: "center",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #444",
    background: "#222",
    color: "#fff",
    boxSizing: "border-box",
  },
  cancelBtn: {
    flex: 1,
    padding: "10px",
    background: "#444",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
  },
  submitBtn: {
    flex: 1,
    padding: "10px",
    background: "#00c6ff",
    background: "linear-gradient(90deg, #00c6ff, #0072ff)",
    color: "#000",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

  const slides = [
    slide1,
    slide2,
    slide3,
    slide4,
    slide5
  ];

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!username || !password) {
      setError("Пожалуйста, заполните все поля.");
      return;
    }

    try {
      const response = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const text = await response.text();
        setError(text || "Неверный логин или пароль");
        return;
      }

      const data = await response.json();
      localStorage.setItem("token", data.token);
      navigate("/");
    } catch (err) {
      setError("Произошла ошибка, попробуйте снова.");
      console.error(err);
    }
  };

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <div className="login-page">
      {/* Левая панель с фоном */}
      <div className="login-left">
        <div className="overlay"></div>

        <div className="text-and-btn">
          <div className="login-text">
            <h1>Skydive Book</h1>
            <p>здесь хранятся твои лучшие эмоции</p>
          </div>

          <button className="how-it-works-btn" onClick={() => setShowModal(true)}>
            Как это работает?
          </button>
        </div>
      </div>

      {/* Правая панель с формой */}
      <div className="login-right">
        <h2>Войти</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Имя пользователя"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="submit">Войти</button>
        </form>
        
        <button
  onClick={() => setForgotOpen(true)}
  style={{
    background: "none",
    border: "none",
    color: "#aaa",
    fontSize: "12px",
    cursor: "pointer",
    // padding: "5px"
  }}
>
  Забыли пароль?
</button>
{forgotOpen && (
  <div style={styles.modalOverlay}>
    <div style={styles.modal}>
      <h3 style={{ marginBottom: "15px" }}>Восстановление пароля</h3>

      <input
        type="email"
        placeholder="Введите email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />

      <div style={{ marginTop: "15px", display: "flex", gap: "10px" }}>
        <button
          onClick={() => setForgotOpen(false)}
          style={styles.cancelBtn}
        >
          Отмена
        </button>

        <button
          onClick={handleForgot}
          style={styles.submitBtn}
          disabled={loadingForgot}
        >
          {loadingForgot ? "Отправка..." : "Отправить"}
        </button>
      </div>
    </div>
  </div>
)}
        {error && <div className="login-error">{error}</div>}
        <div className="signup-link">
          Нет аккаунта? <Link to="/signup">Зарегистрироваться</Link>
        </div>
      </div>

      {/* Модальное окно с инструкцией */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <button className="close-btn" onClick={() => setShowModal(false)}>
              &times;
            </button>

            <div className="slider">
              <button className="nav-btn left" onClick={prevSlide}>&lt;</button>
              <img src={slides[currentSlide]} alt={`slide-${currentSlide}`} />
              <button className="nav-btn right" onClick={nextSlide}>&gt;</button>
            </div>

            <div className="dots">
              {slides.map((_, idx) => (
                <span
                  key={idx}
                  className={`dot ${idx === currentSlide ? "active" : ""}`}
                  onClick={() => setCurrentSlide(idx)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
